export { default } from './Home24Carousel';
